<section class="relative bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 text-white py-20 md:py-28 overflow-hidden">
  <div class="absolute inset-0 pointer-events-none">
    <div class="absolute -top-24 -left-24 w-72 h-72 bg-blue-600/20 rounded-full blur-3xl"></div>
    <div class="absolute -bottom-24 -right-24 w-80 h-80 bg-cyan-500/20 rounded-full blur-3xl"></div>
  </div>

  <div class="container mx-auto px-4 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div>
        <div class="inline-flex items-center px-4 py-1 rounded-full bg-white/10 border border-white/20 text-xs font-semibold tracking-wide mb-4">
          <span class="w-2 h-2 rounded-full bg-emerald-400 mr-2"></span>
          Tier IV Mumbai • Tier III Noida • India Presence
        </div>
        <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4">
          Enterprise Data Centers
          <span class="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
            Built for Critical Workloads in India
          </span>
        </h1>
        <p class="text-slate-200 text-base md:text-lg mb-6 max-w-xl">
          Deploy your infrastructure inside Tier IV data center facilities in Mumbai and Tier III
          data centers in Noida. Designed for high availability, low-latency access across India,
          and stringent physical and network security.
        </p>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
          <div class="bg-white/5 border border-white/10 rounded-xl px-4 py-3">
            <div class="text-sm text-slate-300">Availability</div>
            <div class="text-xl font-semibold text-white">99.99%</div>
          </div>
          <div class="bg-white/5 border border-white/10 rounded-xl px-4 py-3">
            <div class="text-sm text-slate-300">Locations</div>
            <div class="text-xl font-semibold text-white">Mumbai • Noida</div>
          </div>
          <div class="bg-white/5 border border-white/10 rounded-xl px-4 py-3">
            <div class="text-sm text-slate-300">Network</div>
            <div class="text-xl font-semibold text-white">Multi-Carrier</div>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row gap-4">
          <a routerLink="/contact" class="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-sm font-semibold shadow-lg shadow-blue-600/30 transition">
            Talk to Data Center Expert
            <i class="bx bx-right-arrow-alt ml-2 text-lg"></i>
          </a>
          <div class="flex items-center text-slate-300 text-xs md:text-sm">
            <i class="bx bx-shield-quarter text-emerald-400 mr-2 text-lg"></i>
            <span>Redundant power, cooling, and network paths for mission-critical workloads.</span>
          </div>
        </div>
      </div>

      <div class="bg-slate-900/70 border border-slate-700/70 rounded-2xl p-6 md:p-8 shadow-2xl backdrop-blur-xl">
        <div class="flex items-center justify-between mb-6">
          <div>
            <div class="text-xs uppercase tracking-wider text-slate-400 mb-1">India Presence</div>
            <div class="text-xl font-semibold text-white">Active Data Centers</div>
          </div>
          <div class="inline-flex items-center px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-400/40 text-emerald-300 text-xs font-semibold">
            <span class="w-1.5 h-1.5 rounded-full bg-emerald-400 mr-1.5"></span>
            Always On
          </div>
        </div>

        <div class="space-y-4">
          <div class="flex items-start justify-between rounded-xl border border-slate-700 bg-slate-900/80 px-4 py-3">
            <div>
              <div class="flex items-center gap-2 mb-1">
                <span class="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-600/20 text-blue-300">
                  <i class="bx bx-buildings text-lg"></i>
                </span>
                <div>
                  <div class="text-sm font-semibold text-white">Mumbai Data Center</div>
                  <div class="text-xs text-slate-400">Maharashtra, India</div>
                </div>
              </div>
              <div class="flex flex-wrap gap-2 mt-2">
                <span class="px-2 py-0.5 rounded-full bg-emerald-500/10 border border-emerald-400/40 text-emerald-300 text-[11px] font-semibold">
                  Tier IV Facility
                </span>
                <span class="px-2 py-0.5 rounded-full bg-blue-500/10 border border-blue-400/40 text-blue-200 text-[11px] font-semibold">
                  Western Region Hub
                </span>
                <span class="px-2 py-0.5 rounded-full bg-slate-700/60 text-slate-100 text-[11px] font-semibold">
                  Financial Capital
                </span>
              </div>
            </div>
            <div class="text-right">
              <div class="text-xs text-slate-400">Latency (India)</div>
              <div class="text-lg font-semibold text-white">&lt; 20ms</div>
            </div>
          </div>

          <div class="flex items-start justify-between rounded-xl border border-slate-700 bg-slate-900/80 px-4 py-3">
            <div>
              <div class="flex items-center gap-2 mb-1">
                <span class="inline-flex items-center justify-center w-8 h-8 rounded-full bg-cyan-600/20 text-cyan-300">
                  <i class="bx bx-buildings text-lg"></i>
                </span>
                <div>
                  <div class="text-sm font-semibold text-white">Noida Data Center</div>
                  <div class="text-xs text-slate-400">Uttar Pradesh, India</div>
                </div>
              </div>
              <div class="flex flex-wrap gap-2 mt-2">
                <span class="px-2 py-0.5 rounded-full bg-amber-500/10 border border-amber-400/40 text-amber-200 text-[11px] font-semibold">
                  Tier III Facility
                </span>
                <span class="px-2 py-0.5 rounded-full bg-cyan-500/10 border border-cyan-400/40 text-cyan-200 text-[11px] font-semibold">
                  NCR Region Edge
                </span>
                <span class="px-2 py-0.5 rounded-full bg-slate-700/60 text-slate-100 text-[11px] font-semibold">
                  High-Density Racks
                </span>
              </div>
            </div>
            <div class="text-right">
              <div class="text-xs text-slate-400">Latency (NCR)</div>
              <div class="text-lg font-semibold text-white">&lt; 10ms</div>
            </div>
          </div>
        </div>

        <div class="mt-6 grid grid-cols-2 gap-4 text-xs text-slate-300">
          <div class="flex items-center gap-2">
            <i class="bx bx-bolt-circle text-blue-400 text-lg"></i>
            <span>N+N power architecture with diesel generator backup.</span>
          </div>
          <div class="flex items-center gap-2">
            <i class="bx bx-wind text-cyan-300 text-lg"></i>
            <span>Redundant precision cooling for consistent temperatures.</span>
          </div>
          <div class="flex items-center gap-2">
            <i class="bx bx-shield-plus text-emerald-300 text-lg"></i>
            <span>24x7 security, access control, and CCTV monitoring.</span>
          </div>
          <div class="flex items-center gap-2">
            <i class="bx bx-network-chart text-indigo-300 text-lg"></i>
            <span>Carrier-neutral connectivity with diverse fiber paths.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-16 bg-slate-950 border-t border-slate-800/70">
  <div class="container mx-auto px-4">
    <div class="text-center mb-12 max-w-3xl mx-auto">
      <div class="inline-block bg-blue-500/10 border border-blue-500/40 text-blue-300 px-4 py-1 rounded-full text-xs font-semibold mb-3">
        India Data Center Footprint
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-4">
        Tier IV Mumbai and Tier III Noida for Critical Applications
      </h2>
      <p class="text-slate-300 text-sm md:text-base">
        Host your applications on highly resilient infrastructure inside leading Indian data centers.
        Combine metro proximity with enterprise-grade reliability for financial services, SaaS, retail,
        gaming, and public sector workloads.
      </p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-10">
      <div class="bg-slate-900/80 border border-slate-700/80 rounded-2xl p-6 md:p-8">
        <div class="flex items-center justify-between mb-4">
          <div>
            <div class="text-xs uppercase tracking-wider text-blue-300 mb-1">Western Region</div>
            <h3 class="text-xl font-semibold text-white">Mumbai Tier IV Data Center</h3>
          </div>
          <span class="px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-400/40 text-emerald-300 text-[11px] font-semibold">
            Tier IV Facility
          </span>
        </div>
        <p class="text-slate-300 text-sm md:text-base mb-4">
          Ideal for mission-critical banking, fintech, media, and low-latency trading platforms that
          require the highest level of fault tolerance and infrastructure redundancy.
        </p>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-slate-200 mb-4">
          <div class="flex items-start gap-2">
            <i class="bx bx-check-circle text-emerald-400 mt-0.5"></i>
            <span>N+N power redundancy with dual active power paths.</span>
          </div>
          <div class="flex items-start gap-2">
            <i class="bx bx-check-circle text-emerald-400 mt-0.5"></i>
            <span>Multiple independent cooling systems with hot and cold aisle containment.</span>
          </div>
          <div class="flex items-start gap-2">
            <i class="bx bx-check-circle text-emerald-400 mt-0.5"></i>
            <span>Multi-layer physical security with biometric and mantrap access.</span>
          </div>
          <div class="flex items-start gap-2">
            <i class="bx bx-check-circle text-emerald-400 mt-0.5"></i>
            <span>Direct connectivity to major ISPs, IXs, and cloud on-ramps.</span>
          </div>
        </div>
        <div class="flex flex-wrap gap-2 text-[11px] text-slate-200">
          <span class="px-2 py-1 rounded-full bg-slate-800/80 border border-slate-600/70">High Availability</span>
          <span class="px-2 py-1 rounded-full bg-slate-800/80 border border-slate-600/70">Low Latency</span>
          <span class="px-2 py-1 rounded-full bg-slate-800/80 border border-slate-600/70">High-Density Racks</span>
        </div>
      </div>

      <div class="bg-slate-900/80 border border-slate-700/80 rounded-2xl p-6 md:p-8">
        <div class="flex items-center justify-between mb-4">
          <div>
            <div class="text-xs uppercase tracking-wider text-cyan-300 mb-1">Northern Region</div>
            <h3 class="text-xl font-semibold text-white">Noida Tier III Data Center</h3>
          </div>
          <span class="px-3 py-1 rounded-full bg-amber-500/10 border border-amber-400/40 text-amber-200 text-[11px] font-semibold">
            Tier III Facility
          </span>
        </div>
        <p class="text-slate-300 text-sm md:text-base mb-4">
          Designed for high-performance enterprise workloads, SaaS platforms, DR sites, and regional
          deployments that require strong uptime and scalability at optimized cost.
        </p>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-slate-200 mb-4">
          <div class="flex items-start gap-2">
            <i class="bx bx-check-circle text-amber-300 mt-0.5"></i>
            <span>N+1 power and cooling redundancy for predictable availability.</span>
          </div>
          <div class="flex items-start gap-2">
            <i class="bx bx-check-circle text-amber-300 mt-0.5"></i>
            <span>Redundant network paths with carrier-neutral connectivity.</span>
          </div>
          <div class="flex items-start gap-2">
            <i class="bx bx-check-circle text-amber-300 mt-0.5"></i>
            <span>Strong perimeter security with surveillance and access control.</span>
          </div>
          <div class="flex items-start gap-2">
            <i class="bx bx-check-circle text-amber-300 mt-0.5"></i>
            <span>Support for hybrid deployments and DR across regions.</span>
          </div>
        </div>
        <div class="flex flex-wrap gap-2 text-[11px] text-slate-200">
          <span class="px-2 py-1 rounded-full bg-slate-800/80 border border-slate-600/70">Cost Optimized</span>
          <span class="px-2 py-1 rounded-full bg-slate-800/80 border border-slate-600/70">Balanced Redundancy</span>
          <span class="px-2 py-1 rounded-full bg-slate-800/80 border border-slate-600/70">DR Ready</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="location-area ptb-100">
  <div class="container">
    <div class="section-title">
      <h2>Data Center <span class="text-highlight">Locations in India</span></h2>
      <p>
        Presence in strategic metros ensures low-latency access for users and applications across
        India while meeting data residency and compliance requirements.
      </p>
    </div>

    <div class="data-center-tiles">
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="data-center-tile">
            <div class="tile-header">
              <div class="indian-flag">
                <div class="flag-stripe saffron"></div>
                <div class="flag-stripe white"></div>
                <div class="flag-stripe green"></div>
              </div>
              <div class="tile-icon">
                <i class="bx bx-buildings"></i>
              </div>
            </div>
            <div class="tile-content">
              <h3>Mumbai Tier IV Data Center</h3>
              <p class="location-info">
                <i class="bx bx-map"></i>
                <span>Maharashtra, India</span>
              </p>
              <div class="server-count">
                <span class="count">300+</span>
                <span class="label">Active Servers</span>
              </div>
              <div class="features">
                <span class="feature-tag">Tier IV Facility</span>
                <span class="feature-tag">Low Latency</span>
                <span class="feature-tag">Financial Hub</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6">
          <div class="data-center-tile">
            <div class="tile-header">
              <div class="indian-flag">
                <div class="flag-stripe saffron"></div>
                <div class="flag-stripe white"></div>
                <div class="flag-stripe green"></div>
              </div>
              <div class="tile-icon">
                <i class="bx bx-buildings"></i>
              </div>
            </div>
            <div class="tile-content">
              <h3>Noida Tier III Data Center</h3>
              <p class="location-info">
                <i class="bx bx-map"></i>
                <span>Uttar Pradesh, India</span>
              </p>
              <div class="server-count">
                <span class="count">250+</span>
                <span class="label">Active Servers</span>
              </div>
              <div class="features">
                <span class="feature-tag">Tier III Facility</span>
                <span class="feature-tag">NCR Edge</span>
                <span class="feature-tag">Enterprise Grade</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

